
import { Component, Vue, Watch } from 'vue-property-decorator'
import { isOptionalGoods, removeShoppingCart } from "@/api/shoppingMall";
import math from "@/core/math"
import PackageSelector from "@/components/PackageSelector/index.vue";
import {
  BuyCarListDto,
  BuyCarPackageListDto, GetPreOrderInfoParamsDto,
  getShoppingCart,
  modifyShoppingCart,
  PackageListDto
} from "@/api/buyCar";
import { Action, Getter } from "vuex-class";
import StepperTemp from "@/components/StepperTemp/index.vue";
Component.registerHooks(['beforeRouteEnter']);
@Component({
  name: 'BuyCar',
  components: { PackageSelector, StepperTemp }
})
export default class BuyCar extends Vue {
  @Getter companyId!: string
  @Action setPreOrderParams!: (val: GetPreOrderInfoParamsDto) => void;
  @Action setProviderId!: (val: string) => void;

  checkedAll = false
  isEdit = false
  refreshing = false
  shoppingList: BuyCarListDto[] = []
  totalClass = 0
  totalQuantity = 0
  totalAmount = ''
  shopIndex = 0
  goodsIndex = 0
  // 选中的店铺商品数据，用于下单时存储获取预提交订单入参数据
  checkShopData: GetPreOrderInfoParamsDto = {
    customerId: '',
  }
  path = ''

  @Watch('shoppingList', { deep: true })
  changListValue (val: BuyCarListDto[]) {
    let totalClass = 0
    let totalQuantity = 0
    let totalAmount = 0
    let totalCount = 0
    let shopList = []
    if (val && val.length > 0) {
      val.forEach((item) => {
        if (item.goodsPackageList && item.goodsPackageList.length > 0) {
          const { classSum, quantitySum, amountSum } = this.calcSum(item.goodsPackageList)
          totalClass = Number(math.mathAdd(totalClass, classSum))
          totalQuantity = Number(math.mathAdd(totalQuantity, quantitySum))
          totalAmount = Number(math.mathAdd(totalAmount, amountSum))
          const checkGoods = []
          item.goodsPackageList.forEach(i => {
            if (i.isValid) {
              totalCount++
              if (i.isChecked) {
                checkGoods.push({
                  goodsId: i.goodsId,
                  packageId: i.packageId,
                  orderQuantity: i.orderQuantity
                })
              }
            }
          })
          if (checkGoods && checkGoods.length > 0) {
            shopList.push({
              companyId: item.shopId,
              goodsPackageList: checkGoods
            })
          }
        }
      })
      this.checkShopData.shopPackageList = shopList
    }
    // this.checkedAll = totalCount === totalClass
    this.totalClass = totalClass
    this.totalQuantity = totalQuantity
    this.totalAmount = totalAmount.toFixed(2)

    console.log(this.totalClass, this.totalQuantity, this.totalAmount)
  }

  get checkResult () {
    return [].concat(...this.shoppingList.map((item: BuyCarListDto) => {
      return item.goodsPackageList.filter(i => i.isChecked).map(i => ({
        autoId: i.autoId,
        // goodsId: i.goodsId,
        // packageId: i.packageId,
        // orderQuantity: i.orderQuantity
      }))
    }))
  }

  activated () {
    if (window.sessionStorage.getItem('refresh') === '1') {
      window.sessionStorage.setItem('refresh', '0')
      // this.getList()
    }
    // 购物车列表调整为每次都刷新
    this.getList()
  }

  created () {
    this.checkShopData.customerId = this.companyId
    this.getList()
    // this.setProviderId('') 清除掉的话会影响商品列表页进入购物车在返回时调用接口
  }

  mounted () {
    // 注册原生调用h5方法
    this.handleBackBuyCar()
  }

  getList () {
    getShoppingCart({ companyId: this.companyId }).then((res) => {
      this.shoppingList = res.data || []
      if (this.shoppingList && this.shoppingList.length > 0) {
        this.shoppingList.forEach((item: BuyCarListDto) => {
          item.isChecked = false
          item.goodsPackageList.forEach((p: BuyCarPackageListDto) => {
            p.isChecked = false
            p.isEdit = false
          })
        })
        this.shoppingList = JSON.parse(JSON.stringify(this.shoppingList))
        this.checkedAll = false
      }
    }).finally(() => {
      this.refreshing = false
    })

  }

  /**
   * 下拉刷新
   * */
  onRefresh () {
    this.refreshing = true
    this.getList()
  }

  /**
   * 切换数量编辑状态
   * @param shopIndex 店铺列表下标
   * @param packageIndex 店铺下商品列表下标
   * @param isValid 是否有效
   */
  changeEdit (shopIndex, packageIndex, isValid) {
    if (!isValid) return
    this.$set(this.shoppingList[shopIndex].goodsPackageList[packageIndex], 'isEdit', true)
  }

  /**
   * 以店铺为单位，计算种类，数量，金额
   * @param packageList 需计算的店铺数据
   */
  calcSum (packageList: BuyCarPackageListDto[]) {
    // 种类
    let classSum = 0
    // 数量
    let quantitySum = 0
    // 金额
    let amountSum = 0
    if (packageList && packageList.length > 0) {
      packageList.forEach((item: BuyCarPackageListDto) => {
        if (item.isChecked) {
          classSum = Number(math.mathAdd(classSum, 1))
          quantitySum = Number(math.mathAdd(quantitySum, item.orderQuantity))
          if (item.packagePrice) {
            amountSum = Number(math.mathAdd(amountSum, math.mathMultiply(item.packagePrice, item.orderQuantity || 0)))
          }
        }
      })
    }
    return { classSum, quantitySum, amountSum }
  }

  handleFunc () {
    this.isEdit = !this.isEdit
    if (!this.isEdit) {
      this.shoppingList.forEach((list) => {
        list.goodsPackageList.forEach(i => {
          if (!i.isValid) {
            i.isChecked = false
          }
        })
        this.checkGroupChecked(list)
      })
    } else {
      this.shoppingList.forEach((list) => {
        this.checkGroupChecked(list)
      })
    }
    this.checkCheckAll()
  }

  checkGroupChecked (list: BuyCarListDto) {
    list.isChecked = list.goodsPackageList.filter(item => this.isEdit || item.isValid).every(item => item.isChecked)
  }

  /**
   * 购物车商品数量改变时，更新购物车
   * @param index 店铺列表下标
   * @param i 店铺商品列表下标
   * @param value 加购商品数量
   */
  changeQuantity (index, i, value) {
    const goods = this.shoppingList[index].goodsPackageList[i]
    const param = {
      companyId: this.companyId,
      goodsId: goods.goodsId,
      autoId: goods.autoId,
      packageId: goods.packageId,
      shopId: this.shoppingList[index].shopId,
      orderQuantity: value
    }
    this.updateBuyCar(param)
  }

  /**
   * 更新购物车
   * */
  updateBuyCar (param) {
    modifyShoppingCart(param, false).then(() => { }).catch(() => { })
  }

  /* 全选 */
  changeAll () {
    this.shoppingList.forEach((list) => {
      list.goodsPackageList.forEach(i => {
        if (this.isEdit || i.isValid) {
          i.isChecked = this.checkedAll
        }
      })
      this.checkGroupChecked(list)
    })
  }

  checkCheckAll () {
    this.checkedAll = this.shoppingList.every((list) => {
      return list.goodsPackageList.filter(i => this.isEdit || i.isValid).every(i =>
        i.isChecked
      )
    })
  }

  /* 批量删除 */
  deleteShopCar () {
    if (this.checkResult.length <= 0) {
      return this.$toast('请先选择需要删除的商品')
    }
    this.$confirmDialog.show({
      okText: "确认",
      cancelText: "取消",
      tips: "确认要删除吗?",
      onOk: () => {
        return this.delFunc(this.checkResult)
      },
    });
  }

  delFunc (result: { autoId?: string }[]) {
    let params = {
      "autoIdList": result
    }
    removeShoppingCart(params).then(() => {
      this.$toast.success('删除成功')
      this.getList()
      this.checkedAll = false
      this.isEdit = false
    }).catch(() => {
    })
  }

  /* 单个商品删除 */
  delData (id: string) {
    const data = [
      { autoId: id }
    ]
    this.$confirmDialog.show({
      okText: "确认",
      cancelText: "取消",
      tips: "确认要删除吗?",
      onOk: () => {
        return this.delFunc(data)
      },
    });
  }

  beforeClose ({ position, instance }) {
    switch (position) {
      case 'cell':
        break;
      case 'outside':
        instance.close();
        break;
    }
  }

  toDetail (data: BuyCarPackageListDto, shopId: string) {
    if (!data.isValid) return false
    const params = {
      shopId: shopId,
      goodsId: data.goodsId,
      customerId: this.companyId,
    }
    isOptionalGoods(params).then((res) => {
      if (res.data.isOptional) {
        this.setProviderId(shopId)
        this.$router.push({
          path: '/goodsDetail',
          query: {
            goodsId: data.goodsId
          }
        })
      } else {
        this.$dialog.alert({
          message: '商品过期不存在'
        }).then(() => {
          this.getList()
        })
      }
    }).catch(() => {
    })
  }

  handleEmpty () { }

  /**
   * 选择规格之后 更新购物车
   * @param info 选择的套餐信息
   * @param selectValueList // 存储加购弹窗选中的规格，用于加购弹出窗设置默认选中的规格
   */
  getSelectPackageInfo (info: PackageListDto, selectValueList: string[]) {
    this.shoppingList[this.shopIndex].goodsPackageList[this.goodsIndex].packageId = info.packageId
    this.shoppingList[this.shopIndex].goodsPackageList[this.goodsIndex].packageNameDesc = info.packageNameDesc
    this.shoppingList[this.shopIndex].goodsPackageList[this.goodsIndex].packageName = info.packageName
    const goods = this.shoppingList[this.shopIndex].goodsPackageList[this.goodsIndex]
    const param = {
      companyId: this.companyId,
      goodsId: goods.goodsId,
      autoId: goods.autoId,
      packageId: goods.packageId,
      shopId: this.shoppingList[this.shopIndex].shopId,
      orderQuantity: goods.orderQuantity
    }
    // this.updateBuyCar(param)
  }

  /**
   * 打开选择规格弹窗
   * @param data 购物车当前商品数据
   * @param index 店铺列表下标
   * @param i 店铺商品列表下标
   */
  showRules (data: BuyCarPackageListDto, index, i) {
    this.shopIndex = index
    this.goodsIndex = i
    const params = {
      shopId: this.shoppingList[index].shopId,
      goodsId: data.goodsId,
      customerId: this.companyId,
    }
    isOptionalGoods(params).then((res) => {
      if (res.data.isOptional) {
        (this.$refs.packageSelector as any).show({
          ruleType: '4', // type ’1‘加入购物车  ’2‘立即下单  ’3‘选择规格可加购可下单   '4'选择规格确认
          detailInfo: data,
          defaultInfo: data,
          selectValueList: data.packageName.split(',')
        })
      } else {
        this.$dialog.alert({
          message: '商品过期不存在'
        }).then(() => {
          // window.location.reload()
          this.getList()
        })
      }
    }).catch(() => {
    })
  }

  /* 下单 */
  submitOrder () {
    if (this.checkResult.length <= 0) {
      return this.$toast('请先选择需要下单的商品')
    }
    /* 存储获取预提交订单信息入参数据 */
    this.setPreOrderParams(this.checkShopData)
    this.$router.push({
      path: '/submitOrder',
      query: {
        cartFlag: '1' // '1'是购物车进入
      }
    })
  }

  handleBack () {
    this.$router.back()
  }

  // app调用js的方法 跳转回客户管理页面（购物车页面物理返回键需要调用）
  handleBackBuyCar () {
    this.$bridge.registerHandler('handleBackBuyCar', () => {
      this.$router.back()
    })
  }

}
